import { DateTime } from "luxon"
import { Alert, IconButton, Menu } from "@mui/material"
import { useState } from "react"
import MenuOptions, { MenuState } from "../../assets/MenuOptions"
import TableMaker, { TableMakerType } from "../../assets/TableMaker"
import PreLoader from "../../PreLoader"
import { Panel, ViewTriggerAutomatedServiceMap } from "./../types"
import { DeleteForever, Edit, MoreHoriz, PlayArrow, Visibility, MoreTime, Warning } from "@mui/icons-material"

type TriggersTableProps = {
  isLoading: boolean
  error: boolean
  data: ViewTriggerAutomatedServiceMap[]
  panel: Panel
  setModal: React.Dispatch<React.SetStateAction<Panel>>
  setPanel: React.Dispatch<React.SetStateAction<Panel>>
  handleRunService: (id: number) => Promise<void>
}

export default function ServicesTable({ data, setPanel, isLoading, error, setModal, handleRunService }: TriggersTableProps) {
  const [menu, setMenu] = useState<MenuState>({
    anchorEl: null
  })
  console.log(data)
  const format: TableMakerType<ViewTriggerAutomatedServiceMap>[] = [
    { field: 'fk_id_automated_service', header: 'ID', width: .5 },
    { field: 'automated_service_name', header: 'Service name', width: 2, flexGrow: true },
    { field: 'fk_id_automated_service', header: 'Actions', width: .5, renderComponent: (value) => <IconButton id={`button-actions-${value}`} onClick={(e) => setMenu({ anchorEl: e.currentTarget, id: value as number })}><MoreHoriz /></IconButton> },
    { field: 'triggers', header: 'Trigger', width: 3, renderComponent: (value) => Array.isArray(value) ? value.map((item) => item.label).join(', ') : '', flexGrow: true },
    { field: 'path', header: 'Path', width: 2.5 },
    { field: 'service_last_update', header: 'Last Update', width: 1, renderComponent: (value) => <p>{value ? DateTime.fromISO(String(value)).toFormat('dd-LLL-yy') : '-'}</p> },
    { field: 'last_10_update_fail_count', header: '', width: .35, renderComponent: (value) => Number(value) > 0 ? <Warning color={Number(value) <= 5 ? 'warning' : 'error'} /> : <></> }
  ]

  const menuOptions = [
    {
      label: 'Edit',
      icon: <Edit />,
      onClick: () => setPanel({ show: true, id: menu.id, panel: 'edit' })
    },
    {
      label: 'Delete',
      icon: <DeleteForever />,
      onClick: () => setModal({ show: true, id: menu.id })
    },
    {
      label: 'Run',
      icon: <PlayArrow />,
      onClick: () => handleRunService(menu.id!)
    },
    {
      label: 'Last Updates',
      icon: <Visibility />,
      onClick: () => setPanel({ show: true, id: menu.id, panel: 'last-updates' })
    },
    {
      label: 'Schedules',
      icon: <MoreTime />,
      onClick: () => setPanel({ show: true, id: menu.id, panel: 'schedules' })
    }
  ]
  if (isLoading) return <PreLoader />

  if (error) return <Alert severity="error">Error while loading Automated Services.</Alert>

  return <>
    <TableMaker
      data={data}
      format={format}
    />
    <Menu
      id='menu-actions'
      anchorEl={menu.anchorEl}
      open={Boolean(menu.anchorEl)}
      onClose={() => setMenu({ anchorEl: null })}
      onClick={() => setMenu({ anchorEl: null })}
    >
      <MenuOptions
        options={menuOptions}
      />
    </Menu>
  </>
}